import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { useApi } from "utils/hooks/use-api";
import { iamService } from "api/services/iam";
import React, { useEffect } from "react";
import { Chip, Stack } from "@mui/material";
import Button from "components/shared-ui/button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import styles from "./policies-section.module.scss";
import { routeUtils } from "utils/route-utils";
import IAMEntitySearch from "components/shared-ui/iam/sections/entity-search/entity-search";
import { IIAMAttachedPolicy } from "api/entities/iam-policies";

export interface IPoliciesProps {
  policies: IIAMAttachedPolicy[];
  onChange?: (policies: IIAMAttachedPolicy[]) => void;
  isCreate?: boolean;

  onNewPolicy?: () => void;
}

interface ChipData {
  key: number;
  label: string;
}

export default function PoliciesSection(props: IPoliciesProps) {
  const [api, isLoading] = useApi();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<IIAMAttachedPolicy[]>([]);
  const [selected, setSelected] = React.useState<IIAMAttachedPolicy[]>([]);

  const navigate = useNavigate();

  const fetchData = () => {
    api(
      iamService.getPolicies().then((page) =>
        setOptions(
          page.data.map((policy) => {
            return {
              PolicyArn: policy.Arn,
              PolicyName: policy.PolicyName,
              id: policy.id,
            } as IIAMAttachedPolicy;
          })
        )
      )
    );
  };

  const handleDelete = (policyToDetach: IIAMAttachedPolicy) => {
    setSelected((prev) =>
      prev.filter((val) => val.PolicyName !== policyToDetach.PolicyName)
    );
  };

  useEffect(() => {
    if (!open) return;
    fetchData();
  }, [open]);

  useEffect(() => {
    props.onChange?.(selected);
  }, [selected]);

  useEffect(() => {
    setSelected(props.policies);
  }, [props.policies]);

  return (
    <SidePanelSection testId="policies-section" title="Policies">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          gap: "14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <IAMEntitySearch
            isLoading={isLoading}
            placeHolderText="Attach A Policy"
            value={selected}
            options={options}
            getOptionLabel={(option) => option.PolicyName}
            isOptionEqualToValue={(option, value) =>
              option.PolicyName === value.PolicyName
            }
            onChange={(newValue) => {
              setSelected(newValue as IIAMAttachedPolicy[]);
            }}
            onOpen={fetchData}
          />
          <Button
            testId="new-group-link"
            colors="primary"
            onClick={() => props.onNewPolicy?.()}
          >
            <AddIcon />
          </Button>
        </div>

        <Stack
          direction="row"
          spacing={2}
          useFlexGap
          flexWrap="wrap"
          style={{ height: 30 }}
        >
          {selected.map((policy) => (
            <Chip
              className={`${!props.isCreate && styles["chip-clickable"]}`}
              size="medium"
              key={policy.PolicyName}
              label={policy.PolicyName}
              sx={{
                flexDirection: "row",
                fontSize: "1rem",
                alignItems: "center",
                height: 30,
                px: 2,
                "& .MuiChip-label": {},
                "& .MuiChip-deleteIcon": {
                  height: 18,
                  width: 18,
                  backgroundColor: "inherit",
                  ":hover": {
                    backgroundColor: "white",
                  },
                },
              }}
              onClick={
                !props.isCreate
                  ? () => {
                      navigate(
                        routeUtils.getRouteToIAMPolicyDetails(policy.id)
                      );
                    }
                  : undefined
              }
              onDelete={() => {
                handleDelete(policy);
              }}
            />
          ))}
        </Stack>
      </div>
    </SidePanelSection>
  );
}
